import { ClientEndpoint, ClientEndpointType } from "@app/shared";
import { EditLuxcomEndpointConfig } from "./EditLuxcomEndpointConfig";
import { EditWebRelayEndpointConfig } from "./EditWebRelayEndpointConfig";

export type EditEndpointConfigProps = {
    endpoint?: ClientEndpoint;
    value?: string;
    onChange: (json: string | undefined) => any;
};

export const EditEndpointConfig: React.FC<EditEndpointConfigProps> = (props) => {

    if (!props || !props.endpoint)
        return <></>;

    if (props.endpoint.endpointType === ClientEndpointType.Luxcom) {
        return <EditLuxcomEndpointConfig {...props} />;
    }
    if (props.endpoint.endpointType === ClientEndpointType.WebRelay) {
        return <EditWebRelayEndpointConfig {...props} />;
    }

    return <></>;
}
